<template>
  <div
    :class="['wg-row', 'f-align-center', (row.onclick ? 'com-anm22-app-pointer' : ''), 'item-row']"
  >
    <div class="wg-row" style="align-items:center;flex-wrap:nowrap;font-size:18px;">
      <!-- qnt e nome -->
      <div :class="['wg-col', row.weight ? 'wg-xs-5 wg-sm-7' : 'wg-xs-8 wg-sm-9']">
        <div class="wg-row fc-art-name" @click="row.onclick ? row.onclick(row.elem) : ''">
          <div style="margin-right:5px;">{{ row.quantity + 'x' }}</div>
          <div>{{ row.elem.productName }}</div>
        </div>
      </div>
      <!-- peso -->
      <div v-if="row.weight !== null" class="wg-col wg-xs-3 wg-sm-2">
        <div
          class="wg-row"
          style="align-items:center;flex-wrap:nowrap;justify-content:flex-end;"
        >
          <input
            readonly
            v-if="row.weightEdit"
            class="com-anm22-app-align-right"
            type="text"
            style="width:50px;font-size:16px;height:22px;padding:2px;"
            name="weight-prod"
            @focus="$emit('select-input', {event: $event, callback: 'changeRowWeight', data: {id: row.elem.id}})"
            :value="Number(row.weight)"
          >
          <div v-else>{{ Number(row.weight) }}</div>
          <div style="margin-left:2px;">
            {{ $anm22.tableClasses.foodUnitOfMeasurement().getById(row.elem.productUom)['typeClassLiteral'] }}
          </div>
        </div>
      </div>
      <!-- prezzo -->
      <div class="wg-col wg-xs-4 wg-sm-3">
        <div
          class="wg-row"
          style="align-items:center;flex-wrap:nowrap;justify-content:flex-end;cursor:default;"
        >
          <input
            readonly
            v-if="row.priceEdit"
            class="com-anm22-app-align-right"
            type="text"
            style="font-size:16px;width:50px;height:22px;padding:2px;"
            name="price-prod"
            @focus="$emit('select-input', {event: $event, callback: 'changeRowPrice', data: {id: row.elem.id}})"
            :value="Number(row.price).toFixed(2)"
          >
          <div v-else>{{ Number(row.price).toFixed(2) }}</div>
          <div style="margin-left:2px;">€</div>
          <img
            v-if="row.deletable"
            :src="$anm22.icons.getWorldIcon('deleteRed')"
            class="com-anm22-app-img-s"
            style="margin-left:10px;cursor:pointer;"
            @click="$emit('delete-article', row.elem.id)"
          >
        </div>
      </div>
    </div>
    <template v-if="row.elem.variations.length > 0">
      <div
        v-for="(_var,index) in row.elem.variations"
        :key="'var-'+row.elem.id+'-'+index"
        class="wg-row"
        :style="{
          fontSize: '18px',
          paddingLeft: '23px',
          flexWrap: 'nowrap',
          alignItems: 'center',
          marginRight: row.deletable ? '30px' : '0',
          marginTop: '6px'
        }"
      >
        <div class="wg-col wg-xs-9">
          <div>{{ _var.sign + ' ' + $anm22.food_getVariationName(lang, _var) }}</div>
        </div>
        <div class="wg-col wg-xs-3">
          <div
            class="wg-row"
            :style="{
              alignItems:'center',
              flexWrap: 'nowrap',
              justifyContent: 'flex-end',
              cursor:'default'
            }"
          >
            <input
              readonly
              v-if="row.priceEdit"
              :class="['com-anm22-app-align-right']"
              type="text"
              style="width:50px;font-size:16px;height:22px;padding:2px;"
              @focus="$emit('select-input', {event: $event, callback: 'changeVarPrice', data: {id: row.elem.id, index}})"
              :value="Number(_var.price).toFixed(2)"
            >
            <div
              v-else
              style="margin-left:auto;"
            >{{ Number(_var.price).toFixed(2) }}</div>
            <div style="margin-left:2px;">€</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    row: Object,
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    weight() {
      return this.row.weight;
    }
  }
};
</script>

<style lang="scss" scoped>
.item-row {
  margin-top: 12px;
}
.price-sub-zero {
  background-color: red;
  color: #fff;
}
</style>
